import React, { useEffect, useState } from "react";
import { Text } from "react_reusable_components";
import { TwoColumn } from "../../core/layouts";
import variables from "../../themes/base/styles/variables";

const CardContainerStyle = {
  cardMainWrapperStyle: {
    display: variables.dFlex,
    justifyContent: "space-between",
    padding: variables.paddingSmall2,
    alignItems: variables.alignCenter,
    border: `1px solid  ${variables.grey4}`,
    background: variables.whiteSmoke,
    width: variables.mediaContainerWidth,
    flexGrow: "unset",
    cursor: "pointer",
  },
  labelIconWrapperStyle: {
    display: variables.dFlex,
    alignItems: variables.alignCenter,
    gap: variables.gapXS1,
  },
  closeIconStyle: {
    height: variables.closeIcon,
    width: variables.closeIcon,
    cursor: "pointer",
  },
  mediaIconStyle: {
    height: variables.iconWidth,
    width: variables.iconHeight,
    cursor: "pointer",
  },
};
const CardContainer = ({
  title,
  onCrossClick,
  icon,
  onIconClick,
  showElement,
  disabled,
}) => {
  const [inProgress, setInProgress] = useState(false);

  useEffect(() => {
    const audioElement = document.getElementById("audio-element");
    if (showElement && audioElement) {
      audioElement.currentTime = 1e101;
      audioElement.addEventListener("durationchange", function () {
        if (audioElement.duration !== Infinity) {
          audioElement.currentTime = 0;
          audioElement.play();
          audioElement.removeEventListener("durationchange", function () {});//NOSONAR
        }
      });
    }
  }, [showElement]);

  return showElement && inProgress ? (
    showElement
  ) : (
    <TwoColumn
      onClick={() => {
        onIconClick();
        setInProgress(true);
      }}
      style={CardContainerStyle.cardMainWrapperStyle}
      leftSection={
        <TwoColumn
          style={CardContainerStyle.labelIconWrapperStyle}
          leftSection={
            <img
              alt="icon"
              src={icon}
              style={CardContainerStyle.mediaIconStyle}
              onClick={() => {
                setInProgress(true);
              }}
            />
          }
          rightSection={
            <Text
              style={{ fontSize: variables.fontSizeNormal }}
              type="secondary"
            >
              {title}
            </Text>
          }
        />
      }
      rightSectionStyle={{ ...(disabled && { display: "none" }) }}
      rightSection={
        <img
          src={"/icons/close.svg"}
          style={CardContainerStyle.closeIconStyle}
          alt="close"
          onClick={(e) => {
            e.stopPropagation();
            !disabled && onCrossClick();
          }}
        />
      }
    />
  );
};

export default CardContainer;
